import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft, MailOpen, Gift } from "lucide-react";

export default function MailClubMerci() {
  const [params] = useSearchParams();
  const [name, setName] = useState("");
  const [gift, setGift] = useState(null);
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) return;
    let tries = 0;
    const poll = () => api.get(`/mailclub/session/${sid}`).then(r => {
      setName(r.data?.first_name || "");
      if (r.data?.is_gift) {
        setGift(r.data);
        if (!r.data.card_url && tries++ < 10) setTimeout(poll, 2500);
      }
    }).catch(() => {});
    poll();
  }, [params]);

  if (gift) {
    return (
      <div data-testid="mailclub-merci-gift" className="max-w-2xl mx-auto px-6 md:px-12 py-24 text-center">
        <Gift size={48} className="mx-auto text-[#C35A3E] mb-6"/>
        <p className="font-hand text-2xl text-[#A3876A] mb-4">Merci pour ce joli geste</p>
        <h1 className="font-serif text-4xl md:text-5xl mb-8">{name ? `Ton cadeau pour ${name} est confirmé 🎁` : "Ton cadeau est confirmé 🎁"}</h1>
        <p className="text-[#4A4036] leading-relaxed text-lg mb-4">
          {gift.gift_surprise
            ? `${name || "La personne"} n'a pas été prévenue : c'est toi qui annonces la surprise, quand tu veux. Ta carte cadeau à imprimer ou à transférer t'attend aussi dans ta boîte mail.`
            : `${name || "La personne"} vient de recevoir un email lui annonçant ta surprise, avec ta dédicace. Tu peux aussi imprimer une jolie carte à glisser dans une enveloppe.`}
        </p>
        <p className="text-sm text-[#7C7064] mb-10 italic">La première enveloppe partira avec l'envoi du mois prochain, directement à l'adresse indiquée.</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {gift.card_url
            ? <a data-testid="mc-gift-card-link" href={gift.card_url} className="inline-flex items-center justify-center gap-2 bg-[#C35A3E] text-[#FDFBF7] px-8 py-4 hover:bg-[#A94A31] transition-colors"><Gift size={16}/> Voir ma carte cadeau</a>
            : <span className="inline-flex items-center justify-center gap-2 border border-[#E8DCC8] text-[#7C7064] px-8 py-4 text-sm">Préparation de ta carte cadeau…</span>}
          <Link data-testid="mc-back-home" to="/" className="inline-flex items-center justify-center gap-2 border border-[#A3876A] text-[#4A4036] px-8 py-4 hover:bg-[#F5F0E6] transition-colors"><ArrowLeft size={16}/> Retourner sur le site</Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="mailclub-merci-page" className="max-w-2xl mx-auto px-6 md:px-12 py-24 text-center">
      <MailOpen size={48} className="mx-auto text-[#A3876A] mb-6"/>
      <p className="font-hand text-2xl text-[#A3876A] mb-4">Bienvenue dans le club</p>
      <h1 className="font-serif text-4xl md:text-5xl mb-8">
        {name ? `${name}, tu fais partie du club 💌` : "Bienvenue dans le Club de Lettres 💌"}
      </h1>
      <p className="text-[#4A4036] leading-relaxed text-lg mb-4">
        C'est officiel : ton inscription est confirmée.
      </p>
      <p className="text-[#4A4036] leading-relaxed italic mb-4">
        Ta première enveloppe prendra bientôt le chemin de ta boîte aux lettres : elle partira avec l'envoi du mois prochain (chaque paiement du mois vaut pour l'enveloppe du mois suivant).
      </p>
      <p className="text-[#4A4036] leading-relaxed mb-10">
        Maintenant… patience. Et pense à zieuter ta boîte. 👀💌
      </p>
      <p className="text-sm text-[#7C7064] mb-10 italic">
        Un email de bienvenue vient de partir vers toi. Tu peux retrouver et gérer ton abonnement à tout moment depuis ton espace personnel.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link data-testid="mc-back-home" to="/"
          className="inline-flex items-center justify-center gap-2 bg-[#2C2621] text-[#F5F0E6] px-8 py-4 hover:bg-[#1a1613] transition-colors">
          <ArrowLeft size={16}/> Retourner sur Les RDV de l'écriture
        </Link>
        <Link to="/espace"
          className="inline-flex items-center justify-center gap-2 border border-[#A3876A] text-[#4A4036] px-8 py-4 hover:bg-[#F5F0E6] transition-colors">
          Accéder à mon espace
        </Link>
      </div>
    </div>
  );
}
